"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShiftsInWeek = void 0;
const getShiftsInWeek = (week, shifts) => {
    const daysInWeek = week.days.map((dateFormatted) => dateFormatted);
    return shifts.filter((shift) => daysInWeek.includes(shift.date));
};
exports.getShiftsInWeek = getShiftsInWeek;
